import { useFormik } from 'formik';
import XInput from '../common/XInput';
import XModal from '../common/XModal';
import { getDefaultDefendant } from '../../utils/formSchema';
import { generateRandomIds } from '../../utils/helper';
import { DefaultMultiPlaintiffName } from "../../utils/constant";
import { formTitleClasses } from "../common/formClasses";
import * as Yup from "yup";
import AddressForm from '../common/AddressForm';
const defaultDefendant = getDefaultDefendant();

const insuranceFields = [
    ["insurance.insuranceName", "Insurance Name"],
    ["insurance.claimNumber", "Claim Number"],
    ["insurance.adjuster.name", "Adjuster Name"],
    ["insurance.adjuster.email", "Adjuster Email"],
    ["insurance.adjuster.phoneNumber", "Adjuster Phone Number"],
];

const insuranceWrapperClasses = "mb-4";
const insuranceTitleClasses = `${formTitleClasses} mb-6`;
const gridClasses = "grid grid-cols-1 md:grid-cols-2 gap-x-6";

const DefendantModal = ({
    show,
    onClose,
    onSave,
    formik: parentFormik,
    selectedDefendantIndex,
    updateDefendant,
    addNewDefendant
}) => {
    const currentDefendants = parentFormik.values.defendants;
    const isEditMode = selectedDefendantIndex < currentDefendants.length;

    const isReplacingDefault = (
        currentDefendants.length === 1 &&
        currentDefendants[0]?.personalInfo?.name === DefaultMultiPlaintiffName.DEFAULT_DEFENDANT_Name
    );

    const localFormik = useFormik({
        initialValues: isEditMode ? currentDefendants[selectedDefendantIndex] : defaultDefendant,
        enableReinitialize: true,
        validationSchema: Yup.object({
            personalInfo: Yup.object({
                name: Yup.string().trim().required("Defendant Name is required"),
            }),
        }),
        onSubmit: (values) => {
            if (isReplacingDefault) {
                values.defendantId = currentDefendants[0].defendantId;
                addNewDefendant?.(values);
            } else if (isEditMode) {
                updateDefendant?.({ defendantObj: values, index: selectedDefendantIndex });
            } else {
                values.defendantId = generateRandomIds();
                addNewDefendant?.(values);
            }

            onSave?.();
        },
    });

    const getFieldValue = (path) => path.split('.').reduce((acc, key) => acc?.[key], localFormik.values) || '';

    const handleFieldChange = (path, value) => localFormik.setFieldValue(path, value);

    return (
        <XModal
            isOpen={show}
            title="Add Defendant Details"
            onClose={onClose}
            onSubmit={localFormik.handleSubmit}
            submitText="Save"
            size="lg"
        >
            <div className={gridClasses}>
                <div className="mb-4">
                    <XInput
                        label="Defendant Name"
                        name="personalInfo.name"
                        value={getFieldValue('personalInfo.name')}
                        onChange={(e) => handleFieldChange('personalInfo.name', e.target.value)}
                        error={localFormik.touched.personalInfo?.name && localFormik.errors.personalInfo?.name}
                    />
                </div>
            </div>
            <div className={insuranceWrapperClasses}>
                <h2 className={insuranceTitleClasses}>Insurance Details</h2>
                <div className={gridClasses}>
                    {insuranceFields.map(([path, label]) => (
                        <div className="mb-4" key={path}>
                            <XInput
                                label={label}
                                name={path}
                                value={getFieldValue(path)}
                                onChange={(e) => handleFieldChange(path, e.target.value)}
                            />
                        </div>
                    ))}
                </div>
                <AddressForm fieldPath={`insurance.adjuster`} legend="Adjuster Address" formik={localFormik}/>
            </div>
        </XModal>
    );
};

export default DefendantModal;
